const PRELOADER_ACTIVE_CLASS = 'il-preloader-is-active';
const PRELOADER_COMPLETE_CLASS = 'il-preloader-is-complete';
const PRELOADER_MAX_WAIT_MS = 6000;
const MEDIA_SELECTOR = 'img[fetchpriority="high"], img[data-il-preloader-blocking="true"], video[autoplay][data-il-preloader-blocking="true"], iframe[data-il-preloader-blocking="true"]';

let fallbackTimeoutId = null;
let hasActivatedPreloader = false;
let hasHiddenPreloader = false;

const waitForEvent = (element, eventName) => new Promise((resolve) => {
    element.addEventListener(eventName, resolve, { once: true });
});

const waitForDomReady = () => {
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        return Promise.resolve();
    }

    return waitForEvent(document, 'DOMContentLoaded');
};

const waitForWindowLoad = () => {
    if (document.readyState === 'complete') {
        return Promise.resolve();
    }

    return waitForEvent(window, 'load');
};

const waitForImage = (image) => {
    if (image.complete) {
        return Promise.resolve();
    }

    return Promise.race([
        waitForEvent(image, 'load'),
        waitForEvent(image, 'error'),
    ]);
};

const waitForVideo = (video) => {
    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        return Promise.resolve();
    }

    return Promise.race([
        waitForEvent(video, 'loadeddata'),
        waitForEvent(video, 'error'),
    ]);
};

const waitForIframe = (iframe) => {
    if (iframe.dataset.ilPreloaderReady === 'true') {
        return Promise.resolve();
    }

    return Promise.race([
        waitForEvent(iframe, 'load'),
        waitForEvent(iframe, 'error'),
    ]);
};

const waitForBlockingMedia = () => {
    const mediaNodes = Array.from(document.querySelectorAll(MEDIA_SELECTOR));

    if (!mediaNodes.length) {
        return Promise.resolve();
    }

    const mediaPromises = mediaNodes.map((node) => {
        if (node instanceof HTMLImageElement) {
            return waitForImage(node);
        }

        if (node instanceof HTMLVideoElement) {
            return waitForVideo(node);
        }

        if (node instanceof HTMLIFrameElement) {
            return waitForIframe(node);
        }

        return Promise.resolve();
    });

    return Promise.allSettled(mediaPromises);
};

const showPreloader = () => {
    const body = document.body;

    if (!body) {
        waitForDomReady().then(showPreloader);
        return;
    }

    if (hasActivatedPreloader || hasHiddenPreloader) {
        return;
    }

    hasActivatedPreloader = true;
    body.classList.add(PRELOADER_ACTIVE_CLASS);
    body.classList.remove(PRELOADER_COMPLETE_CLASS);
};

const hidePreloader = () => {
    const body = document.body;

    if (!body || hasHiddenPreloader) {
        return;
    }

    hasHiddenPreloader = true;
    window.clearTimeout(fallbackTimeoutId);
    body.classList.add(PRELOADER_COMPLETE_CLASS);
    body.classList.remove(PRELOADER_ACTIVE_CLASS);
};

showPreloader();

Promise.allSettled([
    waitForWindowLoad(),
    waitForBlockingMedia(),
]).then(() => {
    hidePreloader();
});

window.addEventListener('pageshow', hidePreloader);

fallbackTimeoutId = window.setTimeout(hidePreloader, PRELOADER_MAX_WAIT_MS);